import { useUserProfile } from "../hooks/useUserProfile";

//Permite validar si el rol esta permitido
export const validatePermittedRoleButton = (btnRolePermitted: string[]) => {

    //se obtiene el rol desde el SSO
    const { userProfile } = useUserProfile()

    //si no carga, por defecto no esta permitido
    if(userProfile && userProfile.role){
        const role = userProfile.role;

        if (Array.isArray(role)) {
            // Validar si al menos uno de los roles en btnRole está en el arreglo role
            return btnRolePermitted.some(r => role.includes(r));
        } else if (typeof role === 'string') {
            //Si es string, valida que el rol del usuario, cumpla con al menos uno de los permitidos en el boton
            return btnRolePermitted.includes(role);
        }
    }

    return false;
}

